import React from "react";
import TagsInput from "react-tagsinput";
import InputRequire from "views/components/InputRequire";

const KeywordsInput = ({ keywords, onChange, error, disabled, t }) => (
  <div
    className={
      error?.length
        ? "col-lg-9 col-md-9 col-sm-12 m-auto validated"
        : "col-lg-9 col-md-9 col-sm-12 m-auto"
    }
  >
    <label htmlFor="keywords">
      {t("Mots clés")} <InputRequire />
    </label>
    <div>
      <TagsInput
        value={keywords || []}
        disabled={disabled}
        onChange={onChange}
        inputProps={{
          className: "react-tagsinput-input",
          placeholder: "Les mots clés",
          disabled: disabled,
        }}
      />
      {error?.length &&
        error.map((err, index) => (
          <div key={index} className="invalid-feedback">
            {err}
          </div>
        ))}
    </div>
  </div>
);

export default KeywordsInput;
